{
  "__comment.error.app": "Erreurs générées dans l'app - weblate: copier-coller sans traduire cette ligne",
  "__comment.error.backend": "Errors generated from the backend - weblate: copy-paste without translating this line",
  "admin.unauthorized": "You are not allowed to perform this action",
  "anonymous.request": "An error has occurred. If the problem persists, please contact us",
  "app-service.not-connected": "You don't seem to be connected to the internet.",
  "app-service.unavailable.description": "A connection issue is preventing access to the service. Please check your network connection.",
  "app.accessibility.community": "Communities page",
  "app.accessibility.intentions": "Intentions page",
  "app.accessibility.intentions-theme": "Intentions by theme page",
  "app.accessibility.messages": "Messages page",
  "app.accessibility.unsubscribe-donation-mail": "Unsubscribe from donation emails page",
  "app.audio.listen": "Listen to the audio",
  "app.audio.loading-error": "An error occurred while loading the audio file",
  "app.avoidance-navigation.content": "Page content",
  "app.banner.goal.goal": "Objective: {amount} regular donations",
  "app.description": "Thanks to the <strong>Hozana app</strong>, access your prayer corner in one click, discover new communities, and submit your intentions wherever you are!",
  "app.discover": "Discover our programs",
  "app.donation.later.i-want": "Receive a reminder",
  "app.donation.later.success.toast": "You will receive a reminder in a few days",
  "app.download": "Download the app",
  "app.error": "Oops, an error occurred, please try again later.",
  "app.how-to.open-menu": "Menu: open the sidebar menu by pressing Enter, press Esc to close",
  "app.i-donate": "Donate",
  "app.maintenance": "<strong>Hozana</strong> is undergoing maintenance.\nPlease wait a few minutes before refreshing your browser to continue.",
  "app.navigation.events-link": "Hozana meetings!",
  "app.navigation.footer.faq.link": "Questions... and answers!",
  "app.navigation.footer.guide.all": "All the articles in our guides",
  "app.navigation.footer.guide.bible": "Discover the Bible",
  "app.navigation.footer.guide.catechism": "Catechism: answers to your questions!",
  "app.navigation.footer.guide.feast-days": "Christian feast days",
  "app.navigation.footer.guide.meditation": "Christian meditation guide",
  "app.navigation.footer.guide.miracles": "Discover the miracles and apparitions",
  "app.navigation.footer.guide.prayer": "Discover our prayer advice",
  "app.navigation.footer.guide.rosary": "A Guide to the Rosary",
  "app.navigation.footer.guide.saints": "Discover the saints",
  "app.navigation.footer.who.we.are.link": "Who are we?",
  "app.navigation.jobs-link": "Job offers!",
  "app.navigation.main": "Main Menu",
  "app.navigation.open-menu": "Open menu",
  "app.navigation.secondary": "Secondary menu",
  "app.report-abuse.comment": "Report this comment",
  "app.report-abuse.comment.success": "This comment has been flagged, thank you for your help!",
  "app.report-abuse.intention": "Report this intention",
  "app.report-abuse.intention.success": "The intention has been reported, thank you for your help!",
  "app.report-abuse.placeholder": "I am reporting this content because…",
  "app.report-abuse.reason": "Please tell us below why you want to report this content.",
  "app.report-abuse.report": "Abuse reporting",
  "app.report-abuse.send": "Notify",
  "app.report-abuse.uplift": "Report this message for support",
  "app.report-abuse.uplift.success": "This message has been flagged, thank you for your help!",
  "app.report-issue.button": "Report a problem",
  "app.report-issue.thank-you": "Thank you ! Your problem has been reported",
  "auth.complete.choose-password": "Choose a password<br/>to finalize your sign-up with Hozana",
  "auth.complete.not-my-email": "This isn't my e-mail address",
  "auth.login.email": "Log in with email",
  "auth.login.login": "Log in",
  "auth.login.welcome": "Welcome",
  "auth.otp.code.accessibility-label": "Six-digit authentication code",
  "auth.otp.code.description": "We sent a temporary code to: {email}",
  "auth.otp.code.resend": "Resend code",
  "auth.otp.code.title": "Check your email",
  "auth.otp.login.title": "What is your email address?",
  "auth.otp.signup.title": "What is your name?",
  "auth.privacy.notice": "Hozana is free. Here are the <link>terms and conditions</link>. Hozana will never share your email address with a third party without your consent.",
  "auth.signup.signup": "Sign up",
  "auth.social.apple": "Sign in with Apple",
  "auth.social.apple.missing-identity-token": "Apple sign in did not return an identity token",
  "auth.social.google": "Continue with Google",
  "auth.social.google.canceled": "Google sign in was canceled",
  "auth.social.google.missing-authorization-code": "Google sign in did not return an authorization code",
  "birthdate.invalid": "The date of birth is invalid",
  "captcha.invalid": "Verification challenge failed, please try again",
  "captcha.missing": "Please check 'I am not a robot'",
  "captcha.required": "Please complete captcha verification",
  "comment.community.unknown": "Community not found",
  "comment.delete.delete": "Delete comment",
  "comment.delete.fail.none": "The comment could not be deleted",
  "comment.delete.not.found": "The comment you want to delete was not found",
  "comment.form.empty": "Submit your comment",
  "comment.from": "Comment from {contactName}",
  "comment.id.not-found": "Oops, we were unable to display replies for this comment",
  "comment.not-found": "Comment not found",
  "comment.relative.time": "{prefix} {time}",
  "comment.relative.time.today": "Today at {time}",
  "comment.relative.time.week-day": "{weekday} at {time}",
  "comment.relative.time.yesterday": "Yesterday at {time}",
  "comment.relative.week-day": "{weekday}",
  "comment.update.not.found": "The comment you want to edit was not found",
  "comment.write.your-comment": "Your comment",
  "common.error.api.default": "Server connection problem",
  "common.error.unknown": "An error occurred",
  "common.form.error.captcha.invalid": "The captcha is not valid. Please try again.",
  "common.form.error.captcha.required": "Please check \" I am not a robot \"",
  "common.form.error.email.invalid": "Invalid email address",
  "common.form.error.fail": "Unknown error, please try again",
  "common.form.error.field.invalid": "Invalid field, please correct",
  "common.form.error.field.required": "Please fill out this field",
  "common.form.error.message.required": "Message required",
  "common.form.error.password-is-name": "Your password must be different from your name",
  "common.form.error.password.different": "Please confirm with the same password",
  "common.form.error.subject.required": "Subject required",
  "common.word.start-today": "Starts today",
  "common.word.start-tomorrow": "Starts tomorrow",
  "common.word.tomorrow": "Tomorrow",
  "communities.categories": "Categories",
  "communities.categories.all": "All categories",
  "communities.for-you.edit": "Modify my preferences",
  "communities.for-you.empty": "Answer a few questions so that we can suggest the best novena, retreats or daily communities for you.",
  "communities.for-you.settings": "Set my preferences",
  "communities.other-suggestions": "Other current retreats",
  "communities.search": "Your search",
  "communities.see-more": "View more communities",
  "community.activity.inactive": "Inactive",
  "community.all": "All communities",
  "community.already-exists": "A community with the same name already exists",
  "community.close-for-today": "Close for Today",
  "community.communities.none-finished": "You haven't yet completed any novenas, retreats, or communities",
  "community.communities.none-joined": "You haven't joined any novenas, retreats, or communities yet",
  "community.communities.suggested": "Suggested for you",
  "community.communities.team-favorite": "❤️ Favorites of the team",
  "community.communities.view-all": "See all communities",
  "community.creation.suggestion": "You can create and offer to all a new prayer program: novena, retreat or permanent community.",
  "community.date.from-to": "from {fromDate} to {toDate}",
  "community.description.prayer.success": "Thanks for your prayer!",
  "community.description.read-more": "Read more",
  "community.everlasting.unavailable-program": "This community has not yet published any prayer.",
  "community.join-mails.activation": "Enable emails",
  "community.join-mails.subtitle": "This will also serve as a reminder 😉",
  "community.join-mails.title": "Do you want to pray this {lifetime, select, retreat {retreat} novena {novena} other {community}} from your email inbox?",
  "community.join-next.everlasting.start": "A prayer has been published today in the community. Would you like to pray it?",
  "community.join-next.no-publication.start": "While waiting {lifetime, select, novena {for the start of the novena} retreat {for the start of the retreat} other {to receive your first prayer}}, you can…",
  "community.join-next.pray-now": "Pray now",
  "community.join-next.start": "Would you like to start the {lifetime, select, novena {novena} other {retreat}} right now?",
  "community.join-next.start-later": "Start later",
  "community.join.already-joined": "You're already signed up for this program on date",
  "community.join.card.button": "Join {lifetime, select, retreat {the retreat} novena {the novena} other {this community}} midway",
  "community.join.confirmation.in-progress": "You have joined the {lifetime, select, novena {novena} other {retreat}} <strong>midway</strong>.",
  "community.join.confirmation.soon": "You will start the {lifetime, select, retreat {retreat} novena {novena} other {community}} on {date}{rescheduled, select, true {.} other {, <strong>in {nbDays} {nbDays, plural, one {day} other {days}}</strong>.}}",
  "community.join.confirmation.today": "You start the {lifetime, select, retreat {retreat} novena {novena} other {community}} <strong>today.</strong>",
  "community.join.congrats": "Well done {userName}! You are registered in the community",
  "community.join.congrats.comingSoon": "Well done {userName}! You will start the {lifetime, select, novena {novena} other {retreat}} on {date}",
  "community.join.congrats.ongoing": "Well done {userName}! You are joining the {lifetime, select, novena {novena} other {retreat}} starting today",
  "community.join.congrats.startToday": "Well done {userName}! You are starting the {lifetime, select, novena {novena} other {retreat}} today",
  "community.join.date": "Start the {lifetime, select, retreat {retreat} novena {novena} other {community}} on a date that suits you",
  "community.join.date.validate": "Confirm this date",
  "community.join.error.no-subscription": "Oops! There seems to be an issue with the subscription date.",
  "community.join.from-date": "(from day {diffDays})",
  "community.join.infos": "Join the {nbMembers} users who are currently praying {lifetime, select, retreat {the retreat} novena {the novena} other {this community}} right now",
  "community.join.invalid-schedule-date": "The date chosen is not valid",
  "community.join.not-schedulable": "You cannot choose a date for this community",
  "community.join.options.title": "When would you like to start this {lifetime, select, retreat {retreat} novena {novena} other {community}} again?",
  "community.join.scheduled-end-date.novena": "The novena will end on {date}",
  "community.join.scheduled-end-date.retreat": "The retreat will end on the {date}",
  "community.join.success.message": "You have joined the {lifetime, select, retreat {retreat} novena {novena} other {community}}.",
  "community.leave-community": "Leave the community",
  "community.leave-everlasting-community": "No longer receiving prayers",
  "community.leave.already.left": "You have already left this community",
  "community.leave.confirm": "Do you really want to {lifetime, select, novena {stop this novena?} retreat {stop this retreat?} other {leave this community?}}",
  "community.leave.fail": "An error has occurred, please try again",
  "community.leave.success": "You have left the {lifetime, select, novena {novena} retreat {retreat} other {community}}",
  "community.load.error": "An error occurred when charging the community",
  "community.not-found": "This community does not exist",
  "community.not-joined": "You are not or no longer a member of this community.",
  "community.notifications.activate-push": "Activate notifications",
  "community.notifications.receive-publications-push": "Would you like to receive a reminder {lifetime, select, novena {each day of this novena} retreat {each day of this retreat} other {when a prayer is published in this prayer community}}?",
  "community.notifications.receive-publications-push.subtitle": "We will send you a notification {lifetime, select, novena {every day of the novena} retreat {every day of the retreat} other {every time a new prayer is published in the community}}",
  "community.private.private": "Private",
  "community.publication.error.publication.not-accessible": "This publication is not accessible for the moment.",
  "community.role.administrator.long": "You're administrator",
  "community.role.animator.long": "You're animator",
  "community.role.creator.long": "You're the creator",
  "community.share.text": "Maybe someone around you could be interested? Ask the Holy Spirit for guidance 😇",
  "community.status.check.validating": "Pending approval",
  "community.status.draft.word": "A draft",
  "community.tab.description": "Description",
  "community.toolbar.community": "See the {lifetime, select, retreat {retreat} novena {novena} other {community}}",
  "community.toolbar.stop": "Stop the {lifetime, select, retreat {retreat} novena {novena} other {community}}",
  "community.toolbar.title": "Manager's space",
  "community.unavailable-program": "The program for this {lifetime, select, retreat {retreat} other {novena}} is not yet available.",
  "community.unmodifiable": "You cannot modify this community",
  "communityAnnouncement.community.user.not-allowed": "You are not allowed to post an announcement to members of this community",
  "communityAnnouncement.message.too-long": "Oh! Your ad content is too long",
  "communityAnnouncement.subject.too-long": "Oh! Your ad subject is too long",
  "contact.captcha_v2.title": "Please validate that you are a human",
  "contact.email.invalid": "Please enter a valid email address",
  "contact.firstname.invalid": "Please enter your first name",
  "contact.firstname.placeholder": "First name",
  "contact.firstname.tooLong": "First name cannot exceed 30 characters",
  "contact.lastname.invalid": "Please enter your name",
  "contact.lastname.label": "You last name",
  "contact.lastname.placeholder": "Last name",
  "contact.load.error": "An error occurred while searching for your correspondant.",
  "contact.message.alert": "If you report a problem encountered on the site or the application, please detail it as precisely as possible in the fields below:",
  "contact.message.invalid": "Please enter a message",
  "contact.message.label": "Content of your message",
  "contact.message.tooShort": "Message must contain at least 100 characters",
  "contact.send-message": "Send a message",
  "contact.subject.invalid": "Please enter the subject of your message",
  "contact.subject.label": "Subject of your message",
  "contact.subject.placeholder": "Subject",
  "contact.subtitle": "We will be happy to answer you 😊",
  "contact.success.toast": "Your message has been sent. You will get back to you as soon as possible!",
  "content.forbidden-content": "This content is invalid",
  "content.invalid": "The content is not valid or is empty",
  "content.invalid-contain-email": "Your intention must not contain an email",
  "content.invalid-contain-url": "Your intent must not contain a link",
  "content.required": "Content missing",
  "content.too-long": "This content is too long. Please use only letters or numbers",
  "content.too-short": "This content is too short. Please use only letters or numbers",
  "conversation.ambiguous-definition": "Oops, a small problem has occurred. If the problem persists, please contact us",
  "conversation.block": "Block the conversation",
  "conversation.few-seconds": "Right now",
  "conversation.mark-as-unread": "Mark as unread",
  "conversation.not-found": "This conversation does not exist",
  "conversation.unblock": "Unblock conversation",
  "conversation.user.not-allowed": "Oh ! You do not have access to this conversation. Are you sure you are logged in with the correct account?",
  "conversation.you-blocked": "You blocked the conversation",
  "conversations.unread": "Unread",
  "cta.share": "Share",
  "dates.invalid": "The dates are not valid",
  "day.count": "Day {number}",
  "description.forbidden-content": "The description is not valid",
  "description.invalid": "Description is missing",
  "description.required": "Missing description",
  "description.too-long": "The description is too long",
  "description.too-short": "The description is too short",
  "device.delete.not.found": "The device you want to remove was not found",
  "discover.see-more": "See more",
  "draft.conflict": "This post cannot be saved as a draft.",
  "email.already-exists": "This email address already exists",
  "email.invalid": "Invalid email address",
  "email.user.not-found": "No user found with this e-mail address",
  "error.403.title": "You do not have access to this page",
  "error.404.message": "Find communities that can help you pray",
  "error.404.quote": "Seek the Lord while he may be found;\nCall on him while he is near.\nIsaiah 55,6",
  "error.404.title": "Sorry, this page does not exist on Hozana…",
  "favorite.not-found": "Favorite post not found",
  "file.not-an-image": "The uploaded file is not an image. Only JPG / PNG / GIF files are accepted",
  "fromDate.in-the-futur": "Shoot! You need to choose a future date as start date",
  "fromDate.in-the-past": "Damn! You cannot choose a past date as the start date",
  "getCommunitiesJoined.user.not-found": "We cannot find communities",
  "getCommunitiesWithRole.user.not-found": "We cannot find communities",
  "getCommunityNotifications.subscriptionId.not-found": "We could not load your notification preferences for this community",
  "guestName.required": "Missing first name",
  "guestName.too-long": "The first name is too long",
  "guide.not-found": "Articles in this guide were not found",
  "hash.invalid": "An error occurred: 'hash invalid'",
  "hash.required": "An error occurred: 'hash required'",
  "home.faq.title.head": "How does it work?",
  "home.tagline": "Our prayer will save the world",
  "home.tagline.sub": "And it will change your life!",
  "home.welcome.app-section.title": "Download the application",
  "home.welcome.intentions.title": "Lay down your intentions,\npray for others",
  "iframe.error.description": "The content could not be loaded. Check your internet connection and try again.",
  "iframe.error.title": "Connection failed",
  "intention.anonymous-praying": "Anonymous",
  "intention.answer.uplift": "Reply to this message of support",
  "intention.arrival.just-joined": "{userName} just joined Hozana",
  "intention.arrival.welcome-pray": "Wish them welcome in prayer!",
  "intention.birthday.celebration": "{username} turns {years} today!",
  "intention.birthday.pray": "Wish them happy birthday in prayer!",
  "intention.birthday.years-old": "{age, plural, one {{age} year old} other {{age} years old}}",
  "intention.created.description": "It will be proposed to community members for 48 hours.",
  "intention.created.success": "Your intention has been submitted",
  "intention.delete.confirm-message1": "Are you sure you want to delete your currently displayed intention?",
  "intention.delete.confirm-message2": "Those praying will no longer be able to pray for your intention, and you will not be able to thank those who have already prayed for your intention.",
  "intention.delete.delete": "Delete my intention",
  "intention.finished.arrival": "{count, plural, =0 {No one has} one {{count} person has} other {{count} people have}} prayed to welcome you on Hozana!",
  "intention.finished.birthday": "{birthdayDate}, {count, plural, =0 {no one has} one {{count} person has} other {{count} people have}} prayed to wish you a happy birthday!",
  "intention.finished.intention": "The time to display your intention has expired. {count, plural, =0 {Nobody} one {One person} other {{count} people}} prayed for you. <link>See intention</link>",
  "intention.finished.prayers": "{count, plural, =0 {No one} one {{count} person has} other {{count} people have}} prayed {type, select, arrival {to welcome you on Hozana} birthday {for you on your birthday} other {for your intention} }{count, plural, =0 {.} one {, would you like to thank them?} other {, would you like to thank them?}}",
  "intention.finished.thank": "Thank the members",
  "intention.from": "{contactName}'s intention",
  "intention.invitation-to-pray-for": "{name} entrusts their intention to your prayer",
  "intention.load.error": "An error has occurred. The intention could not be loaded.",
  "intention.not-found": "The intention was not found",
  "intention.page.button": "Leave an intention",
  "intention.pray-for": "Pray for intentions",
  "intention.prayed.already": "You prayed for this intention.",
  "intention.prayed.already-with": "You{count, plural, =0 {} one { and another person} other { and # other people} } have prayed for this intention. Thanks!",
  "intention.prayed.birthday": "You{count, plural, =0 {} one { and another person} other { and # people}} prayed for {userName}",
  "intention.prayed.by": "{count, plural, =0 {No one has prayed yet} =1 {{name} has already prayed} =2 {{otherNames} and {name} have already prayed} =3 {{otherNames} and {name} have already prayed} =4 {{otherNames}, {name} and another person has already prayed} other {{otherNames}, {name} and {remainingCount} other people have already prayed}} for this intention",
  "intention.prayed.pray-for-others": "👉🏻 Would you like to pray for other intentions?",
  "intention.prayed.thanks": "Thank you!",
  "intention.prayed.with": "🙏 {count} {count, plural, one {person has prayed} other {people have prayed}} with you for this intention",
  "intention.prayer.not-found": "This user does not seem to have prayed for you",
  "intention.prayer.watchman.activate-notifications": "To be able to receive the notification, you need to activate it.",
  "intention.prayer.watchman.became-watchman": "You are a Prayer Watchman!",
  "intention.prayer.watchman.become": "Become a Prayer Watchman",
  "intention.prayer.watchman.commitment": "You have committed to receiving and praying 3 intentions every day",
  "intention.prayer.watchman.engagement.1": "By becoming <strong>Prayer Watchman</strong>:",
  "intention.prayer.watchman.engagement.2": "3 intentions every day",
  "intention.prayer.watchman.engagement.3": "will be entrusted to your prayers",
  "intention.prayer.watchman.fetching": "We are retrieving the 3 intentions entrusted to you today",
  "intention.prayer.watchman.join": "Become a Prayer Watchman",
  "intention.prayer.watchman.many-watchmen": "🙏 Already <strong>103 456</strong> people engaged!",
  "intention.prayer.watchman.method-reminder": "How would you like to receive your daily prayer reminder?",
  "intention.prayer.watchman.pray-support": "Support your brothers and sisters with your prayers",
  "intention.prayer.watchman.reminder.by-email": "By email",
  "intention.prayer.watchman.reminder.by-notification": "By notification",
  "intention.prayer.watchman.resign": "I want to stop",
  "intention.prayer.watchman.stop": "Stop my commitment",
  "intention.prayers.list.title": "They prayed for you",
  "intention.publish.button": "Entrust my intention",
  "intention.reload": "See other intentions",
  "intention.share": "Share this intention",
  "intention.time-left": "{count}h",
  "intention.title": "Set down your intentions, Pray for those of others",
  "intention.watchman.arrival.just-joined": "You pray for {userName} who just arrived on Hozana",
  "intention.write.here": "Write your prayer intention here",
  "intentions.not-found": "We did not find an intention to display",
  "intentions.title": "Submit your prayer intention on Hozana!",
  "intentions.view": "View intentions",
  "introduction.forbidden-content": "Intro text is invalid",
  "introduction.too-long": "The intro text is too long",
  "introduction.too-short": "The intro text is too short",
  "joinCommunity.community.join.already-finished-community": "This community is finished",
  "journey.discover.current": "See current journeys",
  "journey.empty.active": "You have no ongoing journey.",
  "journey.none.now": "No journeys at the moment",
  "journey.novenas-and-journeys": "Novenas and Journeys",
  "journey.once.subscribed": "Once you've joined a novena or a journey, you'll find it here",
  "journey.prayed.today": "Prayed Today",
  "journey.see-history": "History",
  "lang.unsupported": "The language you are requesting is not currently supported",
  "language.en": "English",
  "language.es": "Spanish",
  "language.fr": "French",
  "language.it": "Italian",
  "language.pl": "Polish",
  "language.pt": "Portuguese",
  "leave.confirm.message": "Your account has been successfully deleted",
  "leave.guides-title": "Discover our thematic guides",
  "leave.pray-differently": "Would you like to pray differently?",
  "leave.sign-up-again": "👋🏻 We will be delighted to welcome you again if you wish to continue praying with us",
  "login.account.disabled": "Your account is deactivated",
  "login.account.missing": "No account with this email address was found",
  "login.code-input.check-email": "Please check the code received by email",
  "login.code.required": "Code required",
  "login.csrf.invalid": "Your session has expired, please try again",
  "login.email.invalid": "Invalid email address",
  "login.email.not-provided": "Please enter your email address",
  "login.email.required": "Email address required",
  "login.failed": "The code is invalid or has expired",
  "login.password.required": "Password required",
  "meeting.organizer.place.name-placeholder": "St. Peter's Church",
  "meeting.organizer.time-invalid": "Please provide a meeting time in HH:MM format",
  "meeting.organizer.timeStart-invalid": "Start time must be less than end time",
  "message.automatic-message": "Automatic message",
  "message.delete": "Delete the message",
  "message.delete.user.not_allowed": "Oh! You can't delete this message",
  "message.deleted": "Message deleted",
  "message.from": "Message from {contactName}",
  "message.godfather.welcome-message.to-godfather": "{contactName} just joined Hozana thanks to your invitation. Welcome them!",
  "message.godfather.welcome-message.to-godson": "You joined Hozana at the invitation of {contactName}. Welcome!",
  "message.godfather.welcome-title.to-godfather": "Here I am",
  "message.godfather.welcome-title.to-godson": "Welcome to Hozana!",
  "message.invalid": "Invalid message",
  "message.list.title": "Messages",
  "message.list.title.conversation": "To start a conversation with another Hozana user, start by praying on the Intentions page.",
  "message.list.title.cta": "Pray for an intention",
  "message.list.title.intention": "The person for whom you will have prayed will be able to thank you and start a conversation with you.",
  "message.prayer-on-arrival.has-thanked-you": "{contactName} thanks you for praying for his arrival on Hozana.",
  "message.prayer-on-arrival.you-thanked-for": "You thanked {contactName} for praying for your arrival on Hozana.",
  "message.prayer-on-birthday.has-thanked-you": "{contactName} thanks you for their birthday.",
  "message.prayer-on-birthday.you-thanked-for": "You thanked {contactName} for praying for your birthday.",
  "message.prayer-on-comment.has-prayed-for-you": "{contactName} prayed for your comment",
  "message.prayer-on-comment.you-prayed-for": "You have prayed for {contactName}'s comment",
  "message.prayer-on-intention.thank-you": "You've thanked {contactName} for praying for your intention",
  "message.prayer-on-intention.thanked-you": "{contactName} thanks you for praying for their intention",
  "message.prayer.has-just-prayed-for-you.short-multiple": "{count} people have prayed for you!",
  "message.prayer.has-just-prayed-for-you.short-single": "{contactName, select, _ {Someone} other {{contactName}}} just prayed for you!",
  "message.prayer.has-prayed-for-you.long": "{contactName} prayed for you",
  "message.prayer.you-prayed-for.long": "You prayed for {contactName}",
  "message.reported": "This message was reported and the conversation blocked. Thank you for your help!",
  "message.suspicious.received": "Your contact sent you a link to click, a number to call, or suggested a place to meet. Please make sure you trust this person before continuing your conversation.",
  "message.suspicious.sent": "It looks like you shared your phone number, email, or a link. Please make sure you trust the person before continuing your conversation on another, less secure, platform.",
  "message.textarea.help.return": "Shift + Enter keys to return to the line",
  "message.unselected": "No conversation selected",
  "message.update.user.not_allowed": "Oh! You cannot edit this message",
  "missing.parameters": "Oops! Some parameters are missing to send a message of support.",
  "name.exists": "Current post name already exists",
  "name.forbidden-content": "This name is not valid",
  "name.invalid": "Invalid first name",
  "name.required": "Enter your name",
  "name.too-long": "This name is too long. Please use only letters or numbers",
  "name.too-short": "This name is too short. Please use only letters or numbers",
  "native.push.how-to.reactivate.description": "By clicking \"Yes, enable notifications\", we'll guide you to your iPhone settings. Simply enable \"Notifications\", then tap the back arrow ⬅️ at the top to return!",
  "navigation.confession-link": "Confess",
  "navigation.guides.title": "Our guides",
  "navigation.intentions": "Submit an intention",
  "navigation.live-page-link": "Live Masses and prayers",
  "navigation.search": "Search on Hozana",
  "notificationEmail.invalid": "Invalid notifications email.",
  "oldPassword.invalid": "Invalid password.",
  "page.gone": "This page no longer exists",
  "page.not-found": "Page not found",
  "password.required": "Password required",
  "password.too-long": "The password is too long",
  "payload.bad-content": "The content is invalid",
  "payload.text-too-long": "Hmm! Your message is too long",
  "pictureFileId.required": "Missing image",
  "postIntention.content.too-long": "The content of the intention is too long",
  "pray.amen": "Amen!",
  "pray.comment.title": "You are praying for {userName}",
  "pray.entrust-intention": "Entrust an intention {buttonText}",
  "pray.entrust-intention.body": "Other Hozana users are praying for your intention.",
  "pray.i-pray.short": "Pray",
  "pray.intention.arrival.title": "You are praying for {userName} who just arrived on Hozana",
  "pray.intention.birthday.title": "It's {userName}'s birthday!",
  "pray.intention.community.show": "Pray for {user}'s intention, who is also {lifetime, select, retreat {signed up for this retreat} novena {signed up for this novena} other {a member of this community}}",
  "pray.intention.publication.done": "Intention submitted by {user}",
  "pray.intention.publication.show": "{user} also prays with \"{community}\", do you want to pray for his intention?",
  "pray.intention.show": "And now, do you want to pray for {user}'s intention?",
  "pray.intention.title": "You pray for the intention of {userName}",
  "pray.pray": "Pray",
  "pray.pray-today": "Pray today",
  "pray.prayed": "Prayed",
  "pray.prayer-sent": "Your prayer intention has been sent",
  "pray.uplift.description": "Only {userName} will see this message",
  "pray.uplift.sent": "Your message of support has been sent",
  "pray.uplift.title": "Would you like to send a supportive message to {userName}?",
  "pray.write-intention": "Do you also want to confide a prayer intention?",
  "pray.your-intention": "Your prayer intention",
  "prayer-space.discover": "This might interest you",
  "prayer-space.everlasting.load.error": "An error occurred when loading the \"Daily\" section",
  "prayer-space.journey.load.error": "An error occurred when loading the \"Novenas and Journeys\" section",
  "prayer-space.onboarding.step-1.description": "The entire Hozana team is delighted to introduce this new Prayer Space, designed to help you grow in faithfulness to daily prayer.",
  "prayer-space.onboarding.step-1.title": "New Prayer Space!",
  "prayer-space.onboarding.step-2.description": "Easily find the novenas and programs you are currently following and see your progress!",
  "prayer-space.onboarding.step-2.title": "Follow Your Novenas and Programs",
  "prayer-space.onboarding.step-3.description": "Find your daily prayers in the “Daily” section: the Gospel of the day, the Liturgy of the Hours, prayers with the saint of the day, and more.",
  "prayer-space.onboarding.step-3.title": "Find Your Daily Prayers",
  "prayer-space.onboarding.step-4.description": "In the “You Might Be Interested” section, discover current suggestions and revisit the novenas and programs you enjoyed praying.",
  "prayer-space.onboarding.step-4.title": "Discover the Richness of Prayer on Hozana",
  "prayer-space.welcome.discover": "All of our propositions",
  "prayer-space.welcome.end-paragraph": "If these propositions do not correspond to what you are looking for, discover the rest of our content, I am sure that you will find a novena, retreat or permanent prayer community that will suit your needs.",
  "prayer-space.welcome.paragraph": "<strong>Hello {userName},</strong>\nWelcome to your <strong>prayer corner</strong> 🙏🏻 !\nHere you will find prayer suggestions.\n👉🏻 To receive prayers, <strong>you can subscribe to a prayer content as of now </strong>",
  "prayer.start": "Start praying",
  "prayerContent.invalid": "The body of the prayer is not valid or is empty",
  "prayerContent.too-long": "Your community's prayer content is too long",
  "prayerName.invalid": "The title of the prayer is not valid or is empty",
  "prayerName.required": "Please give a name to the prayer in your community",
  "prayerName.too-long": "Your community's prayer name is too long",
  "prayerSample.not-found": "Oops! You cannot choose this prayer",
  "publication.already-exists": "An identical publication was scheduled within an hour of interval",
  "publication.comment.loadmore": "Load more comments",
  "publication.comment.loadmoreanswers": "Load more answers",
  "publication.comment.show": "Show comments",
  "publication.comment.title": "{count} {count, plural, one {Comment} other {Comments}}",
  "publication.day": "Day {day}",
  "publication.favorite.add": "Save to favorites",
  "publication.favorite.how-to": "You can save a post by clicking its options button",
  "publication.favorite.none.now": "No favorited posts",
  "publication.favorite.remove": "Do not record",
  "publication.favorite.removed": "The post has been removed from your favorites",
  "publication.favorite.success": "The post has been added to your favorites",
  "publication.frequency.type.daily": "Every day",
  "publication.frequency.type.long.daily": "One prayer per day",
  "publication.frequency.type.long.monthly": "One prayer {value, plural, one {one time} other {# times}} per month",
  "publication.frequency.type.long.sporadically": "A prayer from time to time",
  "publication.frequency.type.long.weekly": "A prayer every {value}",
  "publication.frequency.type.monthly": "{value, plural, one {One time} other {# times}} per month",
  "publication.frequency.type.sporadically": "Occasionally",
  "publication.frequency.type.weekly": "Each {value}",
  "publication.goto": "View the community",
  "publication.load.error": "An error has occurred. The publication could not be loaded.",
  "publication.not-found": "This post was not found",
  "publication.prayed": "🙏 {count} {count, plural, one {person prayed} other {people prayed}} with you",
  "publication.prayed-by": "{count, plural, =0 {You prayed for this publication}=1 {You and one other person prayed for this publication} other {You and {count} others prayed for this publication}}",
  "publication.prayed.share.body": "Share the post or the community 😇",
  "publication.prayed.share.button": "Share now with a friend",
  "publication.prayed.share.choose.body": "By sharing prayer content, you might<strong> deeply transform someone’s life! 😇 </strong>",
  "publication.prayed.share.choose.title": "What do you want to share?",
  "publication.prayed.share.community.button": "I share the community",
  "publication.prayed.share.community.modal.title": "Share this community",
  "publication.prayed.share.publication.button": "I share the post",
  "publication.prayed.share.publication.modal.title": "Share this post",
  "publication.prayed.share.title": "Do you know someone who could be touched by the prayer you just read?",
  "publication.update": "Edit the post",
  "publicationFrequencyType.required": "Please indicate the publication frequency",
  "publicationFrequencyValue.invalid": "The chosen publication frequency is not valid",
  "publicationFrequencyValue.required": "Please enter a publication frequency",
  "push.activated": "Notifications enabled",
  "push.allow.message": "Please now accept your browser's request to activate notifications.",
  "push.blocked.how-to.reactivate": "How to turn on notifications?",
  "push.blocked.how-to.settings.allow": "then allow <i>hozana.org</i> to send out notifications.",
  "push.blocked.how-to.settings.find-hozana": "in the websites list, find <i>hozana.org</i>,",
  "push.blocked.how-to.settings.find-list": "find either the authorizations accorded to the websites or the notification settings,",
  "push.blocked.how-to.settings.icon": "If you do not see this symbol, you will have to go to the browser settings:",
  "push.blocked.how-to.url-icon.allow": "you will then only have to remove the restriction on sending notifications.",
  "push.blocked.how-to.url-icon.browser": "In many browsers, you will find a padlock-shaped icon in the address bar of the site: to the left or right of <i>hozana.org/communaute/…</i>",
  "push.blocked.how-to.url-icon.click": "click on this icon, and find the \"notifications\" option,",
  "push.blocked.message": "You have locked out notifications on this device. Please unlock them if you want to receive notifications from Hozana again.",
  "push.blocked.support-link": "Visit the special help from {browser} for more details in case of problems",
  "push.blocked.title": "Notifications disabled",
  "reportAbuse.reason.required": "You must specify the reason for your report",
  "reportAbuse.type.invalid": "Oops! Technical error: your report was not sent",
  "resetPassword.token.invalid": "An error has occurred: please try again by clicking again on \" Forgot your password? \"",
  "role.invalid": "This role cannot be accepted",
  "rosario.bloc.cta": "I pray the rosary on Rosario",
  "rosario.bloc.description.1": "1 – Form a prayer group of 5 people",
  "rosario.bloc.description.2": "2 – Each day, everyone receives a mystery of the rosary and takes 5 minutes in their day to meditate on it by reciting a decade",
  "rosario.bloc.description.3": "3 – At the end of the day, the group will have meditated on the 5 mysteries of the day, thus completing an entire rosary: it’s the living rosary!",
  "rosario.bloc.title": "Discover the first living rosary application!",
  "rosario.xmrpms.cta": "Join the gift",
  "rosario.xmrpms.description": "In May, the month of Mary, <strong>every decade</strong> prayed on Rosario is <strong>a rose</strong> offered to her!",
  "rosario.xmrpms.objective": "Goal: <strong>5 million roses by May 31st.</strong>",
  "rosario.xmrpms.title": "Join a GREAT gift to Mary",
  "scheduledTime.invalid": "Invalid format for post schedule time",
  "score-threshold-not-met": "The verification score was not met. Please complete the verification.",
  "sendMessage.payload.bad-content": "Hmm! You cannot send the content of this message",
  "settings.account.birthdate": "Birthdate",
  "settings.account.confirm-password": "Confirm your new password",
  "settings.account.current-password": "Your old password",
  "settings.account.delete": "Delete account",
  "settings.account.delete.confirm": "You are about to delete your Hozana account. Please note, this action is irreversible.\n\nTo confirm the complete deletion of your account, enter the word <strong>DELETE</strong> (in capital letters) in the field below and then confirm.",
  "settings.account.delete.error-input": "You must write DELETE here",
  "settings.account.delete.input": "Write DELETE here",
  "settings.account.new-password": "Your new password",
  "settings.card.community.announce": "Receive the announcements",
  "settings.card.community.announce.details": "To allow the community leasers to send you a message",
  "settings.card.community.prayer": "Receive each prayer",
  "settings.card.notifs.email": "By email",
  "settings.card.notifs.push": "By notification",
  "settings.email.disable.all": "Activate emails for all settings",
  "settings.header.notifications": "Emails and notifications",
  "settings.header.title.community": "Community settings",
  "settings.input.email-is-not-valid": "Please fill out a valid email address",
  "settings.input.name-is-not-email": "Please enter a first name only",
  "settings.input.password.label": "Password of your account",
  "settings.input.password.social-connect": "You are connected by an {socialName} account. To connect by password, define one.",
  "settings.input.title.placeholder": "Mr, Mrs, Fr, Sr...",
  "settings.language.title": "Account language",
  "settings.notifications.community-registration.title": "You are signing up to a community, novena or retreat",
  "settings.notifications.disable.all": "Activate notifications for all settings",
  "settings.notifications.end-of-novena.title": "Your journey is ending",
  "settings.notifications.general.description": "Mails and notifications from intentions and other functionalities",
  "settings.notifications.general.title": "General notifications",
  "settings.notifications.incriptions.description": "Emails and notifications of novenas, journeys, and daily content",
  "settings.notifications.incriptions.title": "Notifications linked to my subscription",
  "settings.notifications.intention-end-time.title": "End of display of your prayer intention",
  "settings.notifications.invited-join.title": "Someone new joined Hozana thanks to you",
  "settings.notifications.message.title": "New message",
  "settings.notifications.newsletter.title": "Hozana newsletter",
  "settings.notifications.no-ongoing-community.title": "Reminder to join a journey",
  "settings.notifications.pray-remind.title": "Daily prayer reminder",
  "settings.notifications.watchman-remind.title": "Prayer Leader reminder",
  "settings.notifications.watchman.description": "Settings and reminders",
  "settings.notifications.watchman.title": "You are a Prayer Leader",
  "settings.profile-and-settings": "Profile and settings",
  "settings.unsubscribe-presubscriber.error": "An error occurred during unsubscribe",
  "settings.unsubscribe-presubscriber.success": "You have been unsubscribed",
  "share.community": "Share this {lifetime, select, retreat {retreat} novena {novena} other {community}}",
  "share.community.share": "Share this {lifetime, select, retreat {retreat} novena {novena} other {community}}",
  "share.copied-link": "Link copied",
  "share.copy-link": "Copy link",
  "share.intention.email-body": "Come pray for this intention: {intentionUrl}.",
  "share.intention.share": "Share intention",
  "share.my.intention.email-body": "Come pray for my intention: {intentionUrl}.",
  "share.publication.email-body": "Come discover this publication \"{publicationName}\" on Hozana: {publicationUrl} .",
  "share.share": "Share",
  "share.share-by-email": "Invite people to join by email",
  "share.share-by-email-body": "Come join this {lifetime, select, retreat {retreat} novena {novena} other {community}} sur Hozana « {communityName} » : {url}.",
  "share.wording.send-email": "Share by email",
  "share.wording.share-on-whatsapp": "Share on Whatsapp",
  "signup.captcha.required": "Please click \"I am not a robot\"",
  "signup.code.invalid": "The code is invalid or has expired",
  "signup.email.exists": "An account already exists with this email address",
  "signup.email.invalid": "Invalid email address",
  "signup.email.required": "Email address required",
  "signup.fail": "An error has occurred during the creation of your account",
  "signup.name.invalid": "An error has occurred because of your first name",
  "signup.name.required": "First name required",
  "signup.password.required": "Password required",
  "startConversation.payload.bad-content": "Hmm! You can't send the content of this message",
  "startConversation.user.not-found": "Hmm! Your message must not exceed 10,000 characters",
  "tab.discover": "Discover",
  "tab.error.generic-description": "This tab encountered an error.",
  "tab.error.try-again": "Try again",
  "tab.messaging": "Messages",
  "tab.prayer-space": "Prayer space",
  "tag.not-found": "Tag not found",
  "thanks.prayed.watchman.intentions": "Thank you for your loyalty",
  "timeout-or-duplicate": "The captcha has expired or was already used. Please verify again.",
  "token.expired": "The token, or authentication key, has expired. Please verify that you have used a link to change your password, sent before the last 48 hours.",
  "token.required": "The token, or authentication key, is required",
  "uplift.answer.error": "An error occurred. Your response was not sent.",
  "uplift.message": "Message of support",
  "uplift.message.error": "An error has occurred. Your message of support was not sent.",
  "uplift.textarea.placeholder.long": "Leave a message of support to {userName}...",
  "uplift.textarea.placeholder.short": "Type your message of support...",
  "user.avatar.logo": "My logo",
  "user.communities": "This user suggests",
  "user.communities.other": "See all suggestions",
  "user.delivery-issue-email.alert-message": "There seems to be a problem with your email address",
  "user.delivery-issue-email.hard-bounce-invalid": "<p>There seems to be a problem with your email address. We can't send you the emails that you want to receive from Hozana.😅</p><p>Please confirm your email address.</p>",
  "user.delivery-issue-email.spam-report": "<p>It seems that your email provider is marking our messages as \"Junk Mail\" or \"SPAM\" 😞</p> <p>We invite you to:<br/> • go to your junk mail folder and move the most recent emails from Hozana to your inbox,<br/> • then add \"hello@hozana.org\" to your contacts (or safe sender list).</p> <p>If the problem persists after 3 days, please click the \"Report a problem\" button below.</p>",
  "user.delivery-issue-email.verify-email": "Check my email address",
  "user.happy-birthday.psalm": "For you created my inmost being; you knit me together in my mother’s womb. I praise you because I am fearfully and wonderfully made […]",
  "user.happy-birthday.reference": "Psalm 139, 13-14",
  "user.happy-birthday.title": "Happy birthday\n{username}!",
  "user.happy-birthday.users-pray-for-you": "Today, people are praying for you!",
  "user.happy-birthday.wish": "Happy birthday!",
  "user.home-location": "In what city do you live?",
  "user.logout.word": "Log out",
  "user.mail.unsubscribe": "You will not receive any fundraising emails from us anymore for the following year.",
  "user.not-found": "This user does not exist",
  "user.popins.avatars.choose-my-image": "Choose my profile picture",
  "user.profile.done-communities": "Finished subscriptions",
  "user.profile.favorite-publications": "Favorite publications",
  "user.profile.my-profile": "My profile",
  "user.profile.questions.title.wizard": "And finally, to personalize your prayer",
  "user.profile.questions.you-are": "You are",
  "user.profile.questions.your-birthdate": "For the purposes of praying for you on the day, your birthday is the",
  "user.profile.questions.your-location": "Your City",
  "user.settings.click-to-fill": "Click to fill out",
  "user.settings.tab.account.password-required": "Please enter your password for validation.",
  "user.title.brother": "Brother",
  "user.title.deacon": "Deacon",
  "user.title.family": "Family",
  "user.title.father": "Father",
  "user.title.miss": "Ms",
  "user.title.mr": "Mr",
  "user.title.mrs": "Mrs",
  "user.title.org": "Organization",
  "user.title.sister": "Sister",
  "user.wizard.audio": "Audio",
  "user.wizard.complete": "We're looking\nfor something you might like...",
  "user.wizard.minutes": "min",
  "user.wizard.my-wizard": "My prayer preferences",
  "user.wizard.novena": "Novena",
  "user.wizard.reading": "Reading",
  "user.wizard.video": "Video",
  "user.wizard.welcome.user": "Welcome, {name}!",
  "user.wizard.what-themes": "What topics are you interested in?",
  "user.wizard.what-topics": "Is there a subject that's close to your heart right now?",
  "watchman.daily-counted.intentions": "{count, plural, one {your intention for the day} other {Your {count} intentions for the day}}",
  "watchman.daily.close": "Do you want to stop praying?",
  "watchman.daily.continue": "Continue praying",
  "watchman.daily.intentions": "Your intentions for the day",
  "watchman.daily.pray-for-more": "Pray for more intentions",
  "watchman.daily.remaining": "You have {count} intention{count, plural, one {} other {s}} left for today",
  "watchman.intentions.choice": "Intention selection",
  "watchman.intentions.explanation": "Intentions are chosen at random from those that have received <strong>fewer than 20 prayers</strong>",
  "watchman.intentions.explanation.end": "You can change each intention according to your preferences by clicking the 🔄icon next to each intention.",
  "watchman.pray-for-today": "Pray for today",
  "watchman.prayers.thank-you": "Thank you for your prayers",
  "watchman.prayers.thanks-for": "Thank you for {name}",
  "watchman.push.description": "<strong>Turn on notifications</strong> to better fulfill your commitment as a prayer leader.",
  "watchman.push.details": "You can change your settings at any time.",
  "watchman.push.title": "Stay faithful in prayer.<br/>Get a reminder!",
  "watchman.rely.remains": "{count, plural, one {One person is still counting on your prayer} other {{count} people are still counting on your prayers}}",
  "watchman.three.intentions": "Pray for 3 intentions each day",
  "widget.not-found": "The \"intention\" widget was not found",
  "wizard.communityFormats.unknown": "Oops! little problem, the selection did not work",
  "wizard.communityTypes.unknown": "Oops! little problem, the selection did not work",
  "wizard.prayerDuration.unknown": "Oops! little problem, the selection did not work",
  "wizard.tags.unknown": "Oops! little problem, the selection did not work",
  "word.all.feminine": "All",
  "word.cancel": "Cancel",
  "word.characters": "{count, plural, =0 {No more characters left} one {1 character remaining} other {{count} characters remaining}}",
  "word.choose": "Select",
  "word.close": "Close",
  "word.confirm": "Confirm",
  "word.congratulations": "Cheers!",
  "word.continue": "Continue",
  "word.create.content": "Create content",
  "word.days": "{count, plural, one {# day} other {# days}}",
  "word.edit": "Edit",
  "word.email": "Email",
  "word.email-address": "Email address",
  "word.email-address-connection": "Connection email address",
  "word.email-address-notification": "Email address to receive notifications",
  "word.finish": "Finish",
  "word.in": "in",
  "word.intentions": "Intentions",
  "word.leave-message": "Post",
  "word.next": "Next",
  "word.no": "No",
  "word.notifications": "Notifications",
  "word.notifications.mails": "Notifications and emails",
  "word.prayers": "prayers",
  "word.prayers-count": "{count, plural, one {{count} prayer} other {{count} prayers}}",
  "word.previous": "Previous",
  "word.remove": "Delete",
  "word.save": "Save",
  "word.send": "Submit",
  "word.skip": "Skip",
  "word.start": "Start",
  "word.start-again": "Restart",
  "word.stop": "Stop",
  "word.thank-you": "Thank you",
  "word.today": "Today",
  "word.validate": "Confirm",
  "word.watchman": "Prayer watcher",
  "word.whats-next": "What would you like to do now?",
  "word.yes": "Yes",
  "word.yesterday": "Yesterday",
  "word.you": "You",
  "word.your-firstname": "Your first name",
  "word.your-title": "Title",
  "wording.i-share": "Share now",
  "words.a-man": "A man",
  "words.a-woman": "A woman",
  "words.answer": "Answer",
  "words.by-user": "By {userName}",
  "words.click-here": "Click here",
  "words.contact-us": "Contact us",
  "words.daily": "Daily",
  "words.done": "It's done",
  "words.has-prayed": "{contactName} has prayed",
  "words.hello.user": "Hello {userName},",
  "words.home-page": "Home Page",
  "words.i-check": "Check",
  "words.i-continue": "Continue",
  "words.i-subscribe": "Join",
  "words.in-nb-days": "In {nbDays} {nbDays, plural, one {day} other {days}}",
  "words.in-nb-days-begin": "Starting in {nbDays} {nbDays, plural, one {day} other {days}}",
  "words.know-more": "Learn more",
  "words.maybe-later": "Maybe later",
  "words.nb-days": "{nbDays} {nbDays, plural, one {day} other {days}}",
  "words.no-thanks": "No thanks",
  "words.no-thanks2": "No thanks",
  "words.not-now": "Not now",
  "words.ongoing": "At the moment",
  "words.password.placeholder": "Your password",
  "words.profile": "Profile",
  "words.see": "See",
  "words.see-all.plur-fem": "See all",
  "words.see-all.sing": "See all",
  "words.sign-up": "Join",
  "words.terms-of-use": "Terms of use",
  "words.thank": "Thanks",
  "words.thank-you-very-much": "Thank you so much! 😊",
  "words.thanked": "Thanked",
  "words.you-prayed": "You have prayed",
  "words.your-email-address": "Your e-mail address",
  "words.your-intention": "Your intention",
  "words.your-message": "Your message"
}
